export default __webpack_public_path__ + "static/media/Belt of the Death Master (nm).d10089b7.jpg";